import { CHATBOT_STOPPED_MARKER } from '@/models/chatbot';

export interface StoppedContent {
  content: string;
  interrupted: boolean;
}

export const parseStoppedContent = (content: string): StoppedContent => {
  if (!content.trimEnd().endsWith(CHATBOT_STOPPED_MARKER)) {
    return { content, interrupted: false };
  }

  const markerIndex = content.lastIndexOf(CHATBOT_STOPPED_MARKER);

  return { content: content.slice(0, markerIndex).trimEnd(), interrupted: true };
};
